import { render } from "./ProductCardHome.vue?vue&type=template&id=2070e5ac&scoped=true"
import script from "./ProductCardHome.vue?vue&type=script&lang=js"
export * from "./ProductCardHome.vue?vue&type=script&lang=js"

import "./ProductCardHome.vue?vue&type=style&index=0&id=2070e5ac&scoped=true&lang=css"
import "./ProductCardHome.vue?vue&type=style&index=1&id=2070e5ac&lang=css"

import exportComponent from "/var/www/html/AxumWebPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2070e5ac"]])

export default __exports__